// O que escrever num botão do PDV, e se ele fica aceso.
//
// Três botões trocam de nome conforme o estado da conta: o de bloquear, o do
// fluxo de entrega e o de cancelar. O resto usa o rótulo da configuração. Isso
// eram 75 linhas de `if/switch` no meio do laço que monta a tela.

import { DadosDoPedido } from "../store/Slices/orderSlice";

export interface RotuloEBrilho {
  buttonLabel: any;
  buttonBrightness: any;
}

export function rotuloDoBotao(
  componentProps: any,
  orderDataZustand: DadosDoPedido
): RotuloEBrilho {
  let buttonLabel;
  let buttonBrightness = componentProps.componentBrightness;
  if (componentProps.componentLabel === "toggleAccountLock") {
    buttonLabel =
      orderDataZustand.orderStatus === 5
        ? "Desbloquear Conta"
        : "Bloquear Conta";
  } else if (componentProps.componentLabel === "toggleOrderDeliveryProcess") {
    switch (orderDataZustand.orderStatus) {
      case 0:
        buttonLabel = "Confirmar Pedido";
        break;
      case 1:
        buttonLabel = "Produzir Pedido";
        break;
      case 2:
        buttonLabel = "Enviar Pedido";
        break;
      case 3:
        buttonLabel = "Enviar Pedido";
        break;
      case 4:
        buttonLabel = "Fechar Pedido";
        break;
      case 5:
        buttonLabel = "Adicionar Pagamento";
        break;
      default:
        buttonLabel = componentProps.componentLabel;
    }
    if (orderDataZustand.products?.length === 0) {
      buttonBrightness = "0.2";
    }
  } else if (componentProps.componentLabel === "toggleCancel") {
    let selectedProducts = 0;
    let selectedObservations = 0;

    if (orderDataZustand.products) {
      selectedProducts = orderDataZustand.products.filter(
        (product: any) => product.productSelected || product.productSemiSelected
      ).length;
      selectedObservations = orderDataZustand.products.reduce(
        (total: number, product: any) => {
          return (
            total +
            (product.productObservations?.filter(
              (observation: any) => observation.observationSelected
            ).length || 0)
          );
        },
        0
      );
    }

    switch (true) {
      case selectedProducts === 0 && selectedObservations === 0:
        buttonLabel = "Cancelar Conta";
        break;
      case selectedProducts === 1 && selectedObservations === 0:
        buttonLabel = "Cancelar Produto";
        break;
      case selectedProducts > 1 && selectedObservations === 0:
        buttonLabel = "Cancelar Produtos";
        break;
      case selectedObservations === 1:
        buttonLabel = "Cancelar Observação";
        break;
      case selectedObservations > 1:
        buttonLabel = "Cancelar Observações";
        break;
      default:
        buttonLabel = componentProps.componentLabel;
    }
    if (orderDataZustand.products?.length === 0) {
      buttonBrightness = "0.2";
    }
  } else {
    buttonLabel = componentProps.componentLabel;
  }
  return { buttonLabel, buttonBrightness };
}
